import { accessNotices } from "@/mocks/home";

export default function AccessNotice() {
  return (
    <section className="w-full bg-accent-50 border-y border-accent-200/70">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-primary-600">
              ACCESS GUIDE
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              访问说明 · 三条铁律
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              入口类站点的稳定性取决于访问习惯。记住下面三点，基本可以告别“找不到首页”的情况。
            </p>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            {accessNotices.map((n, i) => (
              <div
                key={n.title}
                className="rounded-lg border border-accent-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                  <i className={`${n.icon} text-lg`}></i>
                </span>
                <p className="mt-4 text-xs font-medium text-primary-600">0{i + 1}</p>
                <h3 className="mt-1 font-heading text-base font-bold text-foreground-950">
                  {n.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                  {n.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}